// constants
import { showSuccessAlert } from "../../constants/alerts";
import { PackagesActionTypes } from "./constants";

const INIT_STATE = {
  packages: [],
  loading: false,
  initialLoading: false,
  error: null,
};

interface PackageActionType {
  type:
    | PackagesActionTypes.API_RESPONSE_SUCCESS
    | PackagesActionTypes.API_RESPONSE_ERROR
    | PackagesActionTypes.GET_PACKAGES
    | PackagesActionTypes.ADD_PACKAGES
    | PackagesActionTypes.DELETE_PACKAGES
    | PackagesActionTypes.UPDATE_PACKAGES
    | PackagesActionTypes.CLEAR_ERROR;

  payload: {
    actionType?: string;
    data?: any | {};
    error?: string;
    message?: string;
  };
}

const Packages = (state: any = INIT_STATE, action: PackageActionType): any => {
  switch (action.type) {
    case PackagesActionTypes.API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case PackagesActionTypes.GET_PACKAGES: {
          return {
            ...state,
            packages: action.payload.data,
            loading: false,
            initialLoading: false,
            error: null,
          };
        }

        case PackagesActionTypes.ADD_PACKAGES: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }

        case PackagesActionTypes.UPDATE_PACKAGES: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }


        case PackagesActionTypes.DELETE_PACKAGES: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }

        default:
          return { ...state };
      }

    case PackagesActionTypes.API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case PackagesActionTypes.GET_PACKAGES: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
            initialLoading: false,
          };
        }
        case PackagesActionTypes.ADD_PACKAGES: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
          };
        }
        case PackagesActionTypes.UPDATE_PACKAGES: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
          };
        }
        case PackagesActionTypes.DELETE_PACKAGES: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
          };
        }

        default:
          return { ...state };
      }

    case PackagesActionTypes.GET_PACKAGES:
      return { ...state, loading: true, initialLoading: true };
    case PackagesActionTypes.ADD_PACKAGES:
      return { ...state, loading: true };
    case PackagesActionTypes.UPDATE_PACKAGES:
      return { ...state, loading: true };
    case PackagesActionTypes.DELETE_PACKAGES:
      return { ...state, loading: true };

    case PackagesActionTypes.CLEAR_ERROR:
      return { ...state, error: null };

    default:
      return { ...state };
  }
};

export default Packages;
